module.exports = __webpack_public_path__ + "media/images/bullhorn-4d6b1c115ba22fe18fbaa6003b1d63f1.svg";